module.exports = "/images/vendor/flag-icon-css/flags/4x3/az.svg?451284cedf7277f87440e014c3c11557";